import { types } from 'mobx-state-tree'

import { formatAsDateAndTime, startOfDayXDaysAgo } from 'utils/datetimeUtils'

import { FilterType } from './FilterType'

export enum DatePreset {
  TODAY = 'Today',
  THIS_WEEK = 'This week',
  THIS_MONTH = 'This month',
  LAST_7_DAYS = 'Last 7 days',
  LAST_30_DAYS = 'Last 30 days',
  LAST_300_DAYS = 'Last 300 days',
}

function getStartDateForPreset(preset: DatePreset): Date {
  switch (preset) {
    case DatePreset.TODAY:
      return startOfDayXDaysAgo(0)
    case DatePreset.THIS_WEEK:
      return startOfDayXDaysAgo(new Date().getDay())
    case DatePreset.THIS_MONTH:
      return startOfDayXDaysAgo(new Date().getDate())
    case DatePreset.LAST_7_DAYS:
      return startOfDayXDaysAgo(7)
    case DatePreset.LAST_30_DAYS:
      return startOfDayXDaysAgo(30)
    case DatePreset.LAST_300_DAYS:
      return startOfDayXDaysAgo(300)
  }
}

const DEFAULT_DATE_PRESET = DatePreset.LAST_7_DAYS

export const DateFilterModel = types
  .model('DateFilterModel')
  .props({
    type: types.literal(FilterType.DATE),

    date_preset: types.optional(
      types.maybeNull(types.enumeration<DatePreset>('DatePreset', Object.values(DatePreset))),
      DEFAULT_DATE_PRESET,
    ),

    start_timestamp: types.optional(types.Date, getStartDateForPreset(DEFAULT_DATE_PRESET)),
    end_timestamp: types.optional(types.Date, () => new Date()),
  })
  .views((self) => ({
    get getFilterAsUrlParam(): string {
      return `start_timestamp=${formatAsDateAndTime(self.start_timestamp)}&end_timestamp=${formatAsDateAndTime(
        self.end_timestamp,
      )}`
    },
    get datePresetOptions(): DatePreset[] {
      return Object.values(DatePreset)
    },
  }))
  .actions((self) => ({
    setDatePreset(preset: DatePreset | null) {
      self.date_preset = preset
      if (preset !== null) {
        self.start_timestamp = getStartDateForPreset(preset)
        self.end_timestamp = new Date()
      }
    },
  }))
